import React, { useState } from 'react'
import { RxCross2 } from "react-icons/rx";

// react form hook
import { useForm } from "react-hook-form";
// import { yupResolver } from "@hookform/resolvers/yup";
import instance from '../../Instance/instance';
// import { profileValidation } from '../../schemas';
import ShowErrorMsg from '../ShowErrorMsg';
import { toast } from 'react-toastify';
import Spinner from "../Spinner"

const CreateProfile = ({ setModal, objInfo }) => {
    const [loader, setLoader] = useState(false)
    const [plusEligible, setPlusEligible] = useState()
    const {
        control,
        handleSubmit,
        register,
        trigger,
        getValues,
        setValue,
        formState: { errors },
    } = useForm({
        defaultValues: {
            preferredName: null,
            name: null,
            familyName: null,
            formerName: null,
            email: null,
            number: null,
            birthday: null,
            profileImg: null,
            consentForm: null,
            accountId: null,
            membership: null,
            plusStatus: null,
            memberSince: null,
            plusEligible: null,
            groups: null,
            country: null,
            addressLine1: null,
            addressLine2: null,
            locality: null,
            administrativeDistrictLevel1: null,
            postalCode: null,
            megaSmsNotifications: null,
        },
        mode: "onBlur",
        // resolver: yupResolver(profileValidation),
    });


    const handleUpdate = async (value) => {
        const body = {
            ...value,
            membership: parseInt(value?.membership),
            megaSmsNotifications: parseInt(value?.megaSmsNotifications),
            plusEligible: parseInt(plusEligible),
            birthday: value?.birthday ? value?.birthday : ""
        }
        try {
            if (!body?.name) return toast.warning("First Name is required")
            if (!body?.familyName) return toast.warning("Last Name is required")
            if (!body?.number) return toast.warning("Phone Number is required")
            setLoader(true)
            const res = await instance.post("/CreateProfile", body)
            if (res?.data?.Message === "Customer Created Successfully") {
                toast.success('Customer created successfully')
                setModal("")
                setLoader(false)
            }
        } catch (err) {
            toast.error("Some error occured")
            setModal("")
            setLoader(false)
        } finally {
            setLoader(false)
        }
    }

    const handleBlur = async (fieldName) => {
        try {
            await trigger(fieldName);
        } catch (error) {
            console.error(error);
        }
    };

    const handleClear = () => {
        setValue("membership", null)
    }
    // useEffect(() => {
    //     gettingCustomerInfo()
    // }, [])


    return (
        <div className='fixed top-0 left-0 w-full bg-[#4a4a4aa0] z-[9992] h-full drop-shadow-2xl  flex justify-center items-center'>
            <div className={`bg-white p-3 w-[650px] overflow-auto h-[610px] rounded-md transition-all relative ease-in-out duration-300 transform`}>
                <div className='flex bg-white rounded-t-md justify-center relative items-center w-full'>
                    <RxCross2 size={20} onClick={() => setModal("")} className='absolute top-2 left-1 cursor-pointer' />
                    <p className='font-semibold text-2xl'>Create Customer</p>
                </div>

                <div className='h-[500px] p-3 overflow-y-auto mt-2  w-full'>

                    <div className='grid grid-cols-2 px-1 items-center border border-1 border-gray-500 mt-3'>
                        <div className='border h-full py-3 border-t-0 border-b-0 border-l-0 border-1 border-r-gray-500'>
                            <label className='font-semibold'>Preferred Name</label>
                        </div>

                        <div className='py-2 pl-4'>
                            <input
                                control={control}
                                {...register("preferredName")}
                                onBlur={() => handleBlur("preferredName")}
                                name="preferredName"
                                type="text" className='border outline-none border-none border-1  border-r-gray-500' placeholder='Preferred Name' />
                        </div>
                    </div>
                    <ShowErrorMsg errors={errors} name="preferredName" />


                    <div className='grid grid-cols-2 px-1 items-center border border-1 border-gray-500 mt-3'>
                        <div className='border h-full py-3 border-t-0 border-b-0 border-l-0 border-1 border-r-gray-500'>
                            <label className='font-semibold'>First Name</label>
                        </div>

                        <div className='py-2 pl-4'>
                            <input
                                control={control}
                                {...register("name")}
                                onBlur={() => handleBlur("name")}
                                name="name"
                                type="text" className='border outline-none border-none border-1  border-r-gray-500' placeholder='First Name' />
                        </div>
                    </div>
                    <ShowErrorMsg errors={errors} name="name" />


                    <div className='grid grid-cols-2 px-1 items-center border border-1 border-gray-500 mt-3'>
                        <div className='border h-full py-3 border-t-0 border-b-0 border-l-0 border-1 border-r-gray-500'>
                            <label className='font-semibold'>Last Name</label>
                        </div>

                        <div className='py-2 pl-4'>
                            <input
                                control={control}
                                {...register("familyName")}
                                onBlur={() => handleBlur("familyName")}
                                name="familyName"
                                type="text" className='border outline-none border-none border-1  border-r-gray-500' placeholder='Last Name' />
                        </div>
                    </div>
                    <ShowErrorMsg errors={errors} name="familyName" />


                    <div className='grid grid-cols-2 px-1 items-center border border-1 border-gray-500 mt-3'>
                        <div className='border h-full py-3 border-t-0 border-b-0 border-l-0 border-1 border-r-gray-500'>
                            <label className='font-semibold'>Former Name</label>
                        </div>

                        <div className='py-2 pl-4'>
                            <input
                                control={control}
                                {...register("formerName")}
                                onBlur={() => handleBlur("formerName")}
                                name="formerName"
                                type="text" className='border outline-none border-none border-1  border-r-gray-500' placeholder='Former Name' />
                        </div>
                    </div>
                    <ShowErrorMsg errors={errors} name="formerName" />


                    <div className='grid grid-cols-2 px-1 items-center border border-1 border-gray-500 mt-3'>
                        <div className='border h-full py-3 border-t-0 border-b-0 border-l-0 border-1 border-r-gray-500'>
                            <label className='font-semibold'>Phone Number</label>
                        </div>

                        <div className='py-2 pl-4'>
                            <input
                                control={control}
                                {...register("number")}
                                onBlur={() => handleBlur("number")}
                                name="number"
                                type="text" className='border outline-none border-none border-1  border-r-gray-500' placeholder='Phone Number' />
                        </div>
                    </div>
                    <ShowErrorMsg errors={errors} name="number" />



                    <div className='grid grid-cols-2 px-1 items-center border border-1 border-gray-500 mt-3'>
                        <div className='border h-full py-3 border-t-0 border-b-0 border-l-0 border-1 border-r-gray-500'>
                            <label className='font-semibold'>Email Address</label>
                        </div>

                        <div className='py-2 pl-4'>
                            <input
                                control={control}
                                {...register("email")}
                                onBlur={() => handleBlur("email")}
                                name="email"
                                type="text" className='border outline-none border-none border-1  border-r-gray-500' placeholder='Email Address' />
                        </div>
                    </div>
                    <ShowErrorMsg errors={errors} name="email" />



                    <div className='grid grid-cols-2 px-1 items-center border border-1 border-gray-500 mt-3'>
                        <div className='border h-full py-3 border-t-0 border-b-0 border-l-0 border-1 border-r-gray-500'>
                            <label className='font-semibold'>Birthday</label>
                        </div>

                        <div className='py-2 pl-4'>
                            <input
                                control={control}
                                {...register("birthday")}
                                onBlur={() => handleBlur("birthday")}
                                name="birthday"
                                type="date" className='border outline-none border-none border-1  border-r-gray-500' placeholder='Email Address' />
                        </div>
                    </div>
                    <ShowErrorMsg errors={errors} name="birthday" />


                    <div className='grid grid-cols-2 px-1 items-center border border-1 border-gray-500 mt-3'>
                        <div className='border h-full py-3 border-t-0 border-b-0 border-l-0 border-1 border-r-gray-500'>
                            <label className='font-semibold'>Consent Form</label>
                        </div>

                        <div className='py-2 pl-4'>
                            <input
                                control={control}
                                {...register("consentForm")}
                                onBlur={() => handleBlur("consentForm")}
                                name="consentForm"
                                type="text" className='border outline-none border-none border-1  border-r-gray-500' placeholder='Consent Form' />
                        </div>
                    </div>
                    <ShowErrorMsg errors={errors} name="consentForm" />



                    <div className='grid grid-cols-2 px-1 items-center border border-1 border-gray-500 mt-3'>
                        <div className='border h-full py-3 border-t-0 border-b-0 border-l-0 border-1 border-r-gray-500'>
                            <label className='font-semibold'>Account Id</label>
                        </div>

                        <div className='py-2 pl-4'>
                            <input
                                control={control}
                                {...register("accountId")}
                                onBlur={() => handleBlur("accountId")}
                                name="accountId"
                                type="text" className='border outline-none border-none border-1  border-r-gray-500' placeholder='Account Id' />
                        </div>
                    </div>
                    <ShowErrorMsg errors={errors} name="accountId" />


                    <div className='grid grid-cols-2 px-1 items-center border border-1 border-gray-500 mt-3'>
                        <div className='border h-full py-3 border-t-0 border-b-0 border-l-0 border-1 border-r-gray-500'>
                            <label className='font-semibold'>Plus Plan</label>
                        </div>

                        <div className='relative py-2 pl-4 flex flex-col gap-1'>
                            <p className='cursor-pointer absolute top-2 right-0 text-sm text-red-600' onClick={handleClear}>Clear</p>

                            <div className='flex gap-1'>
                                <input
                                    disabled={plusEligible === 1 ? true : false}
                                    control={control}
                                    {...register("membership")}
                                    onBlur={() => handleBlur("membership")}
                                    name="membership"
                                    value={'1'}
                                    // defaultChecked={values?.membership == 1 && true}
                                    type="radio" className='border disabled:bg-gray-500 outline-none border-none border-1  border-r-gray-500' />
                                <label>Basic</label>
                            </div>

                            <div className='flex gap-1'>
                                <input
                                    disabled={plusEligible === 1 ? true : false}
                                    control={control}
                                    {...register("membership")}
                                    onBlur={() => handleBlur("membership")}
                                    name="membership"
                                    value={'2'}
                                    // defaultChecked={values?.membership == 2 && true}
                                    type="radio" className='border disabled:bg-gray-500 outline-none border-none border-1  border-r-gray-500' />
                                <label>Member</label>
                            </div>
                        </div>
                    </div>
                    <ShowErrorMsg errors={errors} name="membership" />




                    <div className='grid grid-cols-2 px-1 items-center border border-1 border-gray-500 mt-3'>
                        <div className='border h-full py-3 border-t-0 border-b-0 border-l-0 border-1 border-r-gray-500'>
                            <label className='font-semibold'>Plus Ineligible</label>
                        </div>

                        <div className='py-2 pl-4'>
                            <label className="switch">
                                <input
                                    type="checkbox"
                                    checked={plusEligible === 1 ? true : false}
                                    onChange={(e) => setPlusEligible(plusEligible === 1 ? 0 : 1)}
                                />
                                <span className="slider round"></span>
                            </label>
                            {/* <input
                                control={control}
                                {...register("plusEligible")}
                                onBlur={() => handleBlur("plusEligible")}
                                name="plusEligible"
                                type="number" className='border outline-none border-none border-1  border-r-gray-500' placeholder='Plus Eligible' /> */}
                        </div>
                    </div>
                    <ShowErrorMsg errors={errors} name="plusEligible" />


                    <div className='grid grid-cols-2 px-1 items-center border border-1 border-gray-500 mt-3'>
                        <div className='border h-full py-3 border-t-0 border-b-0 border-l-0 border-1 border-r-gray-500'>
                            <label className='font-semibold'>Plus Status</label>
                        </div>

                        <div className='py-2 pl-4'>
                            <input
                                control={control}
                                {...register("plusStatus")}
                                onBlur={() => handleBlur("plusStatus")}
                                name="plusStatus"
                                type="text" className='border outline-none border-none border-1  border-r-gray-500' placeholder='Plus Status' />
                        </div>
                    </div>
                    <ShowErrorMsg errors={errors} name="plusStatus" />



                    <div className='grid grid-cols-2 px-1 items-center border border-1 border-gray-500 mt-3'>
                        <div className='border h-full py-3 border-t-0 border-b-0 border-l-0 border-1 border-r-gray-500'>
                            <label className='font-semibold'>Member Since</label>
                        </div>

                        <div className='py-2 pl-4'>
                            <input
                                control={control}
                                {...register("memberSince")}
                                onBlur={() => handleBlur("memberSince")}
                                name="memberSince"
                                type="text" className='border outline-none border-none border-1  border-r-gray-500' placeholder='Member Since' />
                        </div>
                    </div>
                    <ShowErrorMsg errors={errors} name="memberSince" />


                    <div className='grid grid-cols-2 px-1 items-center border border-1 border-gray-500 mt-3'>
                        <div className='border h-full py-3 border-t-0 border-b-0 border-l-0 border-1 border-r-gray-500'>
                            <label className='font-semibold'>Groups</label>
                        </div>

                        <div className='py-2 pl-4'>
                            <input
                                control={control}
                                {...register("groups")}
                                onBlur={() => handleBlur("groups")}
                                name="groups"
                                type="text" className='border outline-none border-none border-1  border-r-gray-500' placeholder='Groups' />
                        </div>
                    </div>
                    <ShowErrorMsg errors={errors} name="groups" />



                    <div className='grid grid-cols-2 px-1 items-center border border-1 border-gray-500 mt-3'>
                        <div className='border flex items-center h-full py-3 border-t-0 border-b-0 border-l-0 border-1 border-r-gray-500'>
                            <label className='font-semibold'>Address</label>
                        </div>

                        <div className='flex flex-col'>
                            <div className='py-2 pl-4 border border-b-0 border-l-0 border-r-0 border-t'>
                                <input
                                    control={control}
                                    {...register("country")}
                                    onBlur={() => handleBlur("country")}
                                    name="country"
                                    type="text" className='border outline-none border-none border-1  border-r-gray-500' placeholder='Country' />
                            </div>
                            <div className='ml-3'>
                                <ShowErrorMsg errors={errors} name="country" />
                            </div>

                            <div className='py-2 pl-4 border border-b-0 border-l-0 border-r-0 border-t border-gray-500'>
                                <input
                                    control={control}
                                    {...register("addressLine1")}
                                    onBlur={() => handleBlur("addressLine1")}
                                    name="addressLine1"
                                    type="text" className='border outline-none border-none border-1  border-r-gray-500' placeholder='Street Address' />
                            </div>
                            <div className='ml-3'>
                                <ShowErrorMsg errors={errors} name="addressLine1" />
                            </div>


                            <div className='py-2 pl-4 border border-b-0 border-l-0 border-r-0 border-t border-gray-500'>
                                <input
                                    control={control}
                                    {...register("addressLine2")}
                                    onBlur={() => handleBlur("addressLine2")}
                                    name="addressLine2"
                                    type="text" className='border outline-none border-none border-1  border-r-gray-500' placeholder='Apt/Suit' />
                            </div>
                            <div className='ml-3'>
                                <ShowErrorMsg errors={errors} name="addressLine2" />
                            </div>


                            <div className='py-2 pl-4 border border-b-0 border-l-0 border-r-0 border-t border-gray-500'>
                                <input
                                    control={control}
                                    {...register("locality")}
                                    onBlur={() => handleBlur("locality")}
                                    name="locality"
                                    type="text" className='border outline-none border-none border-1  border-r-gray-500' placeholder='City' />
                            </div>
                            <div className='ml-3'>
                                <ShowErrorMsg errors={errors} name="locality" />
                            </div>


                            <div className='py-2 pl-4 border border-b-0 border-l-0 border-r-0 border-t border-gray-500'>
                                <input
                                    control={control}
                                    {...register("administrativeDistrictLevel1")}
                                    onBlur={() => handleBlur("administrativeDistrictLevel1")}
                                    name="administrativeDistrictLevel1"
                                    type="text" className='border outline-none border-none border-1  border-r-gray-500' placeholder='State' />
                            </div>
                            <div className='ml-3'>
                                <ShowErrorMsg errors={errors} name="administrativeDistrictLevel1" />
                            </div>


                            <div className='py-2 pl-4 border border-b-0 border-l-0 border-r-0 border-t border-gray-500'>
                                <input
                                    control={control}
                                    {...register("postalCode")}
                                    onBlur={() => handleBlur("postalCode")}
                                    name="postalCode"
                                    type="text" className='border outline-none border-none border-1  border-r-gray-500' placeholder='Zip Code' />
                            </div>
                            <div className='ml-3'>
                                <ShowErrorMsg errors={errors} name="postalCode" />
                            </div>

                            <div className='py-2 pl-4 border border-b-0 border-l-0 border-r-0 border-t border-gray-500'>
                                <select
                                    control={control}
                                    {...register("megaSmsNotifications")}
                                    onBlur={() => handleBlur("megaSmsNotifications")}
                                    name="megaSmsNotifications"
                                    className='border outline-none border-none border-1  border-r-gray-500'
                                >
                                    <option disabled selected value="">Select Mega SMS Notification</option>
                                    <option value={"1"}>Yes</option>
                                    <option value={"0"}>No</option>
                                </select>

                            </div>
                            <div className='ml-3'>
                                <ShowErrorMsg errors={errors} name="megaSmsNotifications" />
                            </div>
                        </div>

                    </div>


                </div>

                <div className='flex justify-between items-center mt-2 w-full'>
                    <button onClick={() => setModal("")} className='bg-lightGray font-semibold text-primary border-none outline-none rounded-md py-1 px-6 '>Cancel</button>
                    <button disabled={loader} onClick={handleSubmit(handleUpdate)} className='bg-primary disabled:bg-gray-400 font-semibold text-lightGray border-none outline-none rounded-md py-1 px-6 '>{loader ? <> <Spinner />  </> : "Save"}</button>
                </div>
            </div>
        </div>
    )
}

export default CreateProfile